import React, { useState } from "react";
import { KeyRound } from "lucide-react";

const SLUGS = [
  ["activision", "activision"], ["google", "google"], ["facebook", "facebook"], ["ea", "ea"],
  ["electronic arts", "ea"], ["apple", "apple"], ["steam", "steam"], ["playstation", "playstation"],
  ["psn", "playstation"], ["epic", "epicgames"], ["riot", "riotgames"], ["discord", "discord"],
  ["twitter", "x"], ["supercell", "supercell"], ["tiktok", "tiktok"], ["instagram", "instagram"],
  ["huawei", "huawei"], ["vk", "vk"], ["line", "line"], ["kakao", "kakaotalk"],
];

const slugFor = (name) => {
  const n = (name || "").toLowerCase();
  const hit = SLUGS.find(([k]) => new RegExp(`(^|[^a-z])${k}([^a-z]|$)`).test(n));
  return hit ? hit[1] : null;
};

/** Logo del proveedor de acceso (Simple Icons CDN) con fallback a icono genérico. */
export function AccessMethodIcon({ name, className = "w-4 h-4" }) {
  const [failed, setFailed] = useState(false);
  const slug = slugFor(name);
  if (!slug || failed) return <KeyRound className={`${className} opacity-70`} aria-hidden="true" />;
  return (
    <img src={`https://cdn.simpleicons.org/${slug}/ffffff`} alt="" aria-hidden="true"
      width={16} height={16} loading="lazy" decoding="async"
      className={`${className} object-contain`} onError={() => setFailed(true)} />
  );
}
